import request from "@/utils/request";
import Qs from "qs";

// 线下发票列表
export function invoiceList(data) {
  return request({
    url: "/invoice/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 开票审核
export function examine(data) {
  return request({
    url: "/invoice/audit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 发票详情
export function info(data) {
  return request({
    url: "/invoice/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 发票删除
export function invoiceDel(data) {
  return request({
    url: "/invoice/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
